import PropTypes from 'prop-types';
import InfoPageListItem from '../InfoPageListItem/InfoPageListItem';
import { StyledSpan } from './ItemListLInkTermsPrivacy.style';

const ItemListLinkTermsPrivacy = ({ jumpToSection, children }) => (
  <InfoPageListItem linksTitle>
    <StyledSpan onClick={jumpToSection}>{children}</StyledSpan>
  </InfoPageListItem>
);

ItemListLinkTermsPrivacy.propTypes = {
  children: PropTypes.node.isRequired,
  jumpToSection: PropTypes.func.isRequired,
};

export default ItemListLinkTermsPrivacy;
